import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import isMeteorUser from "../boot/meteor/isMeteorUser";
import { Meteor } from 'meteor/meteor';
export default {
  name: 'RegisterEditAccount',
  // props: {
  //     updateMode: {
  //         type: Boolean,
  //         default: false
  //     }
  // },
  props: {
    updateMode: Boolean
  },
  data: function data() {
    return {
      loginForm: {
        email: undefined,
        password: undefined
      },
      step: 1,
      loginLoad: false
    };
  },
  methods: {
    onClickBack: function onClickBack() {
      location.reload();
    },
    onClickLogin: function onClickLogin() {
      var _this = this;

      this.loginLoad = true;
      this.$q.loading.show({
        delay: 400 // ms

      });
      this.$meteor.loginWithPassword(this.loginForm.email, this.loginForm.password, function (err) {
        if (err) {
          _this.$q.loading.hide();

          _this.$q.notify({
            message: _this.$t('messages.login_failed'),
            color: 'negative'
          });

          _this.loginLoad = false;
        } else {
          _this.$q.loading.hide();

          _this.$q.notify({
            message: _this.$t('messages.login_confirmation'),
            color: 'positive'
          });

          _this.loginLoad = false;
          _this.loginForm.email = '';
          _this.loginForm.password = '';
          isMeteorUser().then(function (response) {
            // console.log('ROUTES.js - Meteor.user().profile.owner', Meteor.user())
            // if true, continue, else redirect to Login page
            // response ? next() : next({ name: 'welcome' })
            // response ? (Meteor.user().profile.owner ? next({ name: 'myOwnedCommunities' }) : (Meteor.user().profile.subs.length > 0 ? next() : next({ name: 'myAreas' }))) : next({ name: 'welcome' })
            // response ? Meteor.user().profile.owner ? next({ name: 'myOwnedCommunities' }) : next() : next({ name: 'welcome' })
            if (response) {
              if (Meteor.user()) {
                if (Meteor.user().profile.owner) {
                  _this.$router.push({
                    name: 'myOwnedCommunities'
                  });
                } else {
                  _this.$router.push({
                    name: 'home2'
                  });
                }
              }
            } else _this.$router.push({
              name: 'welcome'
            });
            /* if (response) {
                if (Meteor.user()) {
                    if (Meteor.user().profile.owner) {
                        this.$router.push({ name: 'myOwnedCommunities' })
                    } else if (!Meteor.user().profile.funding && Meteor.user().profile.tags && Meteor.user().profile.tags.includes('texelpolis')) {
                        this.$router.push({ name: 'funding' })
                    } else {
                        this.$router.push({ name: 'home2' })
                    }
                }
            } else this.$router.push({ name: 'welcome' }) */

          });
          /* if (this.user) {
              console.log('GOGOGGOGO')
              if (this.user.profile.owner) {
                  this.$router.push({ name: 'myOwnedCommunities' })
              } else if (!this.user.profile.funding && this.user.profile.tags && this.user.profile.tags.includes('texelpolis')) {
                  this.$router.push({ name: 'funding' })
              } else {
                  console.log('GOGOGGOGO2')
                  this.$router.push({ name: 'home2' })
              }
          } */
          // this.$router.push({ name: 'myCommunities' })
          // this.step = 4
        }
      });
    },
    onClickForgot: function onClickForgot() {
      var _this2 = this;

      this.$q.dialog({
        title: this.$t('pages.welcome.forgot_password'),
        message: this.$t('pages.welcome.forgot_password_dialog'),
        prompt: {
          model: '',
          isValid: function isValid(val) {
            return val.length > 2;
          } // << here is the magic

        },
        cancel: true,
        persistent: true
      }).onOk(function (email) {
        _this2.resetPassword(email); // console.log('>>>> OK, received', data)

      });
    },
    resetPassword: function resetPassword(email) {
      var _this3 = this;

      /* this.loginLoad = true
      this.$q.loading.show({
          delay: 400 // ms
      }) */
      // console.log(this.$meteor)
      // this.$meteor.accounts.forgotPassword({ email }, (err) => {
      this.$meteor.call('forgotPW', email, function (err) {
        if (err) {
          console.log('forgorpassword ERROR', err);

          _this3.$q.loading.hide();

          _this3.$q.notify({
            message: _this3.$t('messages.password_forgot_failed'),
            color: 'negative'
          });

          _this3.loginLoad = false;
        } else {
          _this3.$q.loading.hide();

          _this3.$q.notify({
            message: _this3.$t('messages.password_forgot'),
            color: 'info'
          }); // this.loginLoad = false
          // this.loginForm.email = ''
          // this.loginForm.password = ''
          // this.$router.push({ name: 'Projects' })
          // this.step = 4

        }
      });
    }
  },
  watch: {
    user: {
      immediate: true,
      handler: function handler(val) {// console.log('user', this.user)

        /*
                        if (this.user) {
                            if (this.user.profile.owner) {
                                this.$router.push({ name: 'myOwnedCommunities' })
                            } else if (!this.user.profile.funding && this.user.profile.tags && this.user.profile.tags.includes('texelpolis')) {
                                this.$router.push({ name: 'funding' })
                            } else {
                                this.$router.push({ name: 'home2' })
                            }
                        }
        */
      }
    }
  },
  computed: _objectSpread({}, mapGetters(['user', 'measuresMine']), {
    layout: function layout() {
      return this.$q.screen.lt.sm || this.$q.screen.lt.md;
    }
  })
};